module.exports = __webpack_public_path__ + "bf7ad63fc9df63a7b13422f17da0fda9.png";